import React, { useState } from "react";
import Input from "@src/components/UIElements/Input";
import Dropdown from "../../UIElements/Dropdown";
import { useSelector } from "react-redux";

function AddressFields({
  label,
  placeholder,
  value,
  setValue,
  errorMessage,
  isMandatory,
  list,
  type,
  length,
  maxLength,
  isVisible = true,
  errorCondition,
}) {
  const [error, setError] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState(value || "");

  const verify = (value) => {
    if (value?.length < length) {
      setError(true);
    } else {
      setError(false);
    }
    if (errorCondition) {
      setError(true);
    }
  };
  const isPhysicalDeliveryEnabled = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isPhysicalDeliveryEnabled
  );
  const pincodeErrorMsg = useSelector(
    (state) => state?.physicalShipmentReducer?.picodeErrorMessage
  );

  if (!isVisible) {
    return <></>;
  }

  return (
    <div className="AddressField">
      <div className="AddressField__Label">{label}</div>
      <div className="AddressField__Input">
        {list?.length ? (
          <Dropdown
            customClass="AddressField__Input__List"
            heading={
              <Input
                value={value || searchInputValue}
                onChange={(e) => {
                  if (maxLength !== undefined) {
                    if (e?.target?.value?.length <= maxLength) {
                      setSearchInputValue(
                        e.target.value?.replace(/\s\s+/g, " ")
                      );
                    }
                  } else {
                    setSearchInputValue(e.target.value?.replace(/\s\s+/g, " "));
                  }
                }}
                placeholder={placeholder}
                onBlur={(e) => verify(e?.target?.value)}
                type={type}
                maxLength={maxLength}
                onClick={() => {
                  setSearchInputValue("");
                  setValue("");
                }}
              />
            }
          >
            {(searchInputValue
              ? list?.filter((item) =>
                  item?.name
                    ?.toLowerCase()
                    ?.includes(searchInputValue?.toLowerCase())
                )
              : list
            )?.map((item) => (
              <div
                key={item?.key}
                className="AddressField__Input__List--Item"
                onClick={() => {
                  setSearchInputValue(item?.name);
                  setValue(item?.name);
                }}
              >
                {item?.name}
              </div>
            ))}
          </Dropdown>
        ) : (
          <Input
            value={value}
            onChange={(e) => {
              if (maxLength !== undefined) {
                if (e?.target?.value?.length <= maxLength) {
                  setValue(e.target.value?.replace(/\s\s+/g, " "));
                }
              } else {
                setValue(e.target.value?.replace(/\s\s+/g, " "));
              }
            }}
            placeholder={placeholder}
            onBlur={(e) => verify(e?.target?.value)}
            type={type}
            maxLength={maxLength}
          />
        )}
        {isPhysicalDeliveryEnabled &&
        value?.length === 6 &&
        label === "Pincode*" ? (
          <p style={{ color: "#FF0000", fontSize: "13px", marginTop: "4px" }}>
            {pincodeErrorMsg}
          </p>
        ) : null}
        {error  ? (
          <div className="AddressField__Input--Error">{errorMessage}</div>
        ) : null}
      </div>
    </div>
  );
}

export default AddressFields;
